import { navItems } from "@/mocks/site";
import {
  COMPANY_NAME,
  POSTAL,
  ADDRESS,
  TEL_DISPLAY,
  TEL_HREF,
  EMAIL,
  EMAIL_HREF,
  HOURS,
  HOLIDAY,
  LINE_URL,
  LINE_COLOR,
  FORM_ANCHOR,
  WEBSITE,
  INSTAGRAM_URL,
  MASCOT_WORK,
} from "@/constants";

const footerNav = [...navItems, { label: "お問い合わせ", href: "#contact" }];

export default function Footer() {
  return (
    <>
      <footer className="bg-background-200 pb-28 pt-14 lg:pb-12">
        <div className="site-container">
          <div className="grid gap-10 lg:grid-cols-[1.3fr_1fr_1fr]">
            <div>
              <div className="flex items-center gap-3">
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-background-50 p-1">
                  <img src={MASCOT_WORK} alt="株式会社小林建設のイメージキャラクター" className="h-full w-full object-contain" />
                </span>
                <div>
                  <p className="text-[10px] font-bold text-primary-700">春日部市の不用品回収・遺品整理</p>
                  <p className="font-heading text-lg font-black text-foreground-900">{COMPANY_NAME}</p>
                </div>
              </div>
              <ul className="mt-5 space-y-2 text-sm text-foreground-700">
                <li className="flex items-start gap-2">
                  <i className="ri-map-pin-2-line mt-0.5 text-primary-600" />
                  {POSTAL} {ADDRESS}
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-phone-line text-primary-600" />
                  <a href={TEL_HREF} className="font-bold hover:text-primary-700">
                    {TEL_DISPLAY}
                  </a>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line text-primary-600" />
                  <a href={EMAIL_HREF} className="min-w-0 break-words hover:text-primary-700">
                    {EMAIL}
                  </a>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-time-line mt-0.5 text-primary-600" />
                  {HOURS}／{HOLIDAY}
                </li>
              </ul>
            </div>

            <div>
              <p className="font-heading text-sm font-black text-foreground-900">メニュー</p>
              <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5">
                {footerNav.map((item) => (
                  <li key={item.label}>
                    <a
                      href={item.href}
                      className="text-sm font-bold text-foreground-700 transition-colors hover:text-primary-700"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
              <div className="mt-5 flex flex-wrap gap-2">
                <a
                  href={WEBSITE}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex cursor-pointer items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3 py-2 text-xs font-bold text-foreground-700 transition-colors hover:bg-background-100"
                >
                  <i className="ri-global-line" />
                  <span className="whitespace-nowrap">コーポレートサイト</span>
                </a>
                <a
                  href={INSTAGRAM_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex cursor-pointer items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3 py-2 text-xs font-bold text-foreground-700 transition-colors hover:bg-background-100"
                >
                  <i className="ri-instagram-line" />
                  <span className="whitespace-nowrap">Instagram</span>
                </a>
              </div>
            </div>

            <div className="flex flex-col gap-3">
              <p className="font-heading text-sm font-black text-foreground-900">お問い合わせ</p>
              <a
                href={TEL_HREF}
                className="flex cursor-pointer items-center justify-center gap-2 rounded-md bg-primary-600 px-4 py-3.5 font-heading font-black text-background-50 transition-colors hover:bg-primary-700"
              >
                <i className="ri-phone-fill text-lg" />
                <span className="whitespace-nowrap text-sm">電話で無料相談</span>
              </a>
              <a
                href={LINE_URL}
                target="_blank"
                rel="noopener noreferrer"
                style={{ backgroundColor: LINE_COLOR }}
                className="flex cursor-pointer items-center justify-center gap-2 rounded-md px-4 py-3.5 font-heading font-black text-white transition-all hover:brightness-95"
              >
                <i className="ri-line-fill text-lg" />
                <span className="whitespace-nowrap text-sm">LINEで写真相談</span>
              </a>
              <a
                href={FORM_ANCHOR}
                className="flex cursor-pointer items-center justify-center gap-2 rounded-md border border-primary-300 bg-background-50 px-4 py-3.5 font-heading font-black text-primary-700 transition-colors hover:bg-primary-50"
              >
                <i className="ri-mail-send-line text-lg" />
                <span className="whitespace-nowrap text-sm">無料見積もりフォーム</span>
              </a>
            </div>
          </div>

          <div className="mt-10 flex flex-col items-center gap-2 border-t border-background-300 pt-6 md:flex-row md:justify-between">
            <p className="text-xs text-foreground-500">
              © 2026 {COMPANY_NAME} All Rights Reserved.
            </p>
            <p className="text-[11px] text-foreground-500">
              埼玉県春日部市の不用品回収・遺品整理／リフォーム
            </p>
          </div>
        </div>
      </footer>

      <div className="fixed bottom-0 left-0 right-0 z-50 grid grid-cols-2 border-t border-background-300 bg-background-50 lg:hidden">
        <a
          href={TEL_HREF}
          className="flex flex-col items-center justify-center gap-1 bg-primary-600 py-3 text-background-50"
        >
          <i className="ri-phone-fill text-2xl" />
          <span className="text-sm font-black">電話で無料相談</span>
        </a>
        <a
          href={LINE_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{ backgroundColor: LINE_COLOR }}
          className="flex flex-col items-center justify-center gap-1 py-3 text-white"
        >
          <i className="ri-line-fill text-2xl" />
          <span className="text-sm font-black">LINEで無料見積</span>
        </a>
      </div>
    </>
  );
}